export default __webpack_public_path__ + "static/media/banner1.b02fa830.jpg";